import React, { createContext, useState, useMemo } from "react";
import { node } from "prop-types";

const initialState = {};

export const CustomContext = createContext(initialState);

export function CustomStore({ children }) {
  const [state, setState] = useState(initialState);
  const providerState = useMemo(() => ({ state, setState }), [state, setState]);
  return (
    <CustomContext.Provider value={providerState}>
      {children}
    </CustomContext.Provider>
  );
}

CustomStore.defaultProps = {
  children: null,
};

CustomStore.propTypes = {
  children: node,
};
